import { useState } from 'react'

export function useSidebar() {
  const [isOpen, setIsOpen] = useState(false)
  const [isCollapsed, setIsCollapsed] = useState(false)

  return {
    isOpen,
    isCollapsed,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
    toggle: () => setIsOpen((v) => !v),
    toggleCollapse: () => setIsCollapsed((v) => !v),
  }
}
